var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("el-tag", [
            _vm._v("\n      " + _vm._s(_vm.memberLabel.labelName) + "\n    "),
          ]),
          _vm._v(" "),
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: {
              size: "small",
              placeholder: "请输入会员名称",
              clearable: "",
            },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.getMemberComboPage },
            },
            [_vm._v("\n      查询\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "success" },
              on: { click: _vm.handleLabelBindMember },
            },
            [_vm._v("\n      绑定\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.memberList,
            multiple: "",
            stripe: "",
            border: "",
            fit: "",
            size: "mini",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "会员编码", prop: "userFnId", width: "120" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "会员名称", prop: "userName" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "会员别名", prop: "alias", width: "120" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, next",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              total: _vm.total,
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }